import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const WALLET: PaymentMethod = {
    id: PAYMENT_METHOD_ID.Wallet,
    name: 'vivawallet',
    displayName: 'viva.com'
};
